/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Delivery(props) {
    return (
        <SvgIcon {...props}>
            <g>
                <path d="M18,8.072v3.509h-1.714c0-1.722-0.857-2.583-2.571-2.583h-0.857c-1.715,0-2.572,0.861-2.572,2.583 c0,0-0.857,0-2.571,0c0-1.722-0.857-2.583-2.571-2.583c-0.857,0-0.857,0-0.857,0c-1.714,0-2.572,0.861-2.572,2.583H0.006 L0,8.029h11.142V3.723h2.572C16.345,4.291,18,8.072,18,8.072z" />
            </g>
            <path d="M4.716,9.694c-1.182,0-2.144,0.965-2.144,2.153C2.572,13.034,3.534,14,4.716,14s2.142-0.966,2.142-2.153 C6.858,10.659,5.897,9.694,4.716,9.694z M4.737,13.03c-0.65,0-1.182-0.53-1.182-1.183c0-0.65,0.532-1.182,1.182-1.182 c0.65,0,1.182,0.532,1.182,1.182C5.919,12.5,5.388,13.03,4.737,13.03z" />
            <path d="M13.287,9.694c-1.181,0-2.144,0.965-2.144,2.153c0,1.187,0.963,2.153,2.144,2.153 c1.182,0,2.142-0.966,2.142-2.153C15.429,10.659,14.469,9.694,13.287,9.694z M13.35,13.03c-0.65,0-1.182-0.53-1.182-1.183 c0-0.65,0.532-1.182,1.182-1.182s1.182,0.532,1.182,1.182C14.532,12.5,14,13.03,13.35,13.03z" />
            <g>
                <g>
                    <rect y="2" width="10.286" height="5.167" />
                </g>
            </g>
        </SvgIcon>
    );
}

Delivery.defaultProps = {
    viewBox: '0 0 18 16'
};

export default Delivery;
